import type { JobProfileVersion } from '~/shared/data-contract/job-profile-versions';

type VersionCandidate = Pick<JobProfileVersion, 'publishedAt' | 'reviewedAt' | 'version'>;

const highestVersion = (versions: readonly VersionCandidate[]): VersionCandidate | undefined =>
    versions.reduce<VersionCandidate | undefined>(
        (best, candidate) => (best === undefined || candidate.version > best.version ? candidate : best),
        undefined,
    );

// The version a comparison column shows by default: newest published, else newest reviewed, else newest draft.
export const resolveWinningVersion = (versions: readonly VersionCandidate[] | undefined): string | undefined => {
    if (versions === undefined || versions.length === 0) {
        return undefined;
    }

    const winner =
        highestVersion(versions.filter((version) => version.publishedAt !== null)) ??
        highestVersion(versions.filter((version) => version.reviewedAt !== null)) ??
        highestVersion(versions);

    return winner?.version.toString();
};
